export class NfSaidaItemCancelado {
    produtoId = null;
    unidade = null;
    quantidade = null;
    valor = null;
    subtotal = null;
    codigo = null;
    codigoBarra = null;
    descricao = null;

    constructor(item) {
      this.produtoId = item.produtoId;
      this.unidade = item.unidade;
      this.quantidade = item.quantidade;
      this.valor = item.valor;
      this.subtotal = item.subtotal;
      this.codigo = item.codigo;
      this.codigoBarra = item.codigoBarra;
      this.descricao = item.descricao;
    }
}